@use '@hevoio/hevo-ui-toolkit/styles/variables' as v;

.page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: v.$surface-bg;

  // EntityList uses h-100 which would claim the full page height.
  // flex:1 makes it fill only the remaining space after the header.
  :global(.body-container) {
    flex: 1;
    height: auto;
    min-height: 0;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
  }
}
